import { solarContractBundle } from "./solar-contract-bundle"
import { ContractDrawer } from "../../ProposalSetup/contract/ContractDrawer"

/**
 * Contract status at /solar-proposal/:proposalId/contract: the shared Contract
 * drawer over Solar's readiness, send, fixes and language. The Setup rail stays
 * open beside it, and a read-only viewer may open it to see status and history.
 */
export const SolarContractDrawer = (): JSX.Element | null => (
  <ContractDrawer bundle={solarContractBundle} />
)
